import React from "react";
import Coursecard from "./Coursecard";
import { universities } from "./universities";

export default function Smu() {

  const courses = universities.find(
    (u) => u.university === "Sikkim Manipal University"
  ).courses;

  return (

    <>

      {/* CONTENT AREA */}

      <section className="py-5" style={{ background: "#f8f9ff" }}>
        <div className="container">
          <div className="row align-items-center">

            {/* LEFT SIDE */}
            <div className="col-lg-5">

              <span
                className="badge mb-3 px-3 py-2"
                style={{ background: "#6C63FF" }}
              >
                ABOUT SMU
              </span>

              <h1 className="fw-bold mb-4">
                Sikkim Manipal
                <span style={{ color: "#6C63FF" }}> University</span>
              </h1>

              <p className="text-muted">
                Sikkim Manipal University is a renowned institution committed
                to delivering quality education through innovative teaching,
                academic excellence, and industry-relevant programs.
              </p>

              <p className="text-muted">
                With experienced faculty, modern learning resources, and a
                strong focus on career development, SMU helps students build
                successful futures in a rapidly evolving world.
              </p>

              <div className="row mt-4">

                <div className="col-6 mb-3">
                  <div className="bg-white shadow-sm rounded-4 p-3 text-center">
                    <h4 className="fw-bold text-primary">50K+</h4>
                    <small>Students</small>
                  </div>
                </div>

                <div className="col-6 mb-3">
                  <div className="bg-white shadow-sm rounded-4 p-3 text-center">
                    <h4 className="fw-bold text-danger">80+</h4>
                    <small>Programs</small>
                  </div>
                </div>

                <div className="col-6">
                  <div className="bg-white shadow-sm rounded-4 p-3 text-center">
                    <h4 className="fw-bold text-success">200+</h4>
                    <small>Faculty</small>
                  </div>
                </div>

                <div className="col-6">
                  <div className="bg-white shadow-sm rounded-4 p-3 text-center">
                    <h4 className="fw-bold text-warning">90%</h4>
                    <small>Placement Support</small>
                  </div>
                </div>

              </div>

            </div>

            {/* RIGHT SIDE */}
            <div className="col-lg-7">

              <div
                className="position-relative mx-auto"
                style={{
                  width: "500px",
                  height: "500px",
                  maxWidth: "100%"
                }}
              >

                {/* Orbit */}
                <div
                  style={{
                    width: "380px",
                    height: "380px",
                    border: "2px dashed #c9c7ff",
                    borderRadius: "50%",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)"
                  }}
                />

                {/* Center Logo */}
                <div
                  className="bg-white shadow-lg rounded-circle d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "200px",
                    height: "200px",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%,-50%)"
                  }}
                >
                  <img
                    src="/smulogo.png"
                    alt="SMU"
                    style={{ width: "120px" }}
                  />
                </div>

                {/* Top */}
                <div
                  className="bg-primary text-white rounded-circle shadow d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "100px",
                    height: "100px",
                    top: "0",
                    left: "50%",
                    transform: "translateX(-50%)"
                  }}
                >
                  <i className="bi bi-building fs-1"></i>
                </div>

                {/* Left */}
                <div
                  className="bg-success text-white rounded-circle shadow d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "100px",
                    height: "100px",
                    left: "0",
                    top: "50%",
                    transform: "translateY(-50%)"
                  }}
                >
                  <i className="bi bi-book fs-1"></i>
                </div>

                {/* Right */}
                <div
                  className="bg-danger text-white rounded-circle shadow d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "100px",
                    height: "100px",
                    right: "0",
                    top: "50%",
                    transform: "translateY(-50%)"
                  }}
                >
                  <i className="bi bi-mortarboard fs-1"></i>
                </div>

                {/* Bottom Left */}
                <div
                  className="bg-warning rounded-circle shadow d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "100px",
                    height: "100px",
                    bottom: "20px",
                    left: "70px"
                  }}
                >
                  <i className="bi bi-laptop fs-1"></i>
                </div>

                {/* Bottom Right */}
                <div
                  className="bg-info text-white rounded-circle shadow d-flex justify-content-center align-items-center position-absolute"
                  style={{
                    width: "100px",
                    height: "100px",
                    bottom: "20px",
                    right: "70px"
                  }}
                >
                  <i className="bi bi-trophy fs-1"></i>
                </div>

              </div>

            </div>

          </div>
        </div>
      </section>


      {/* COURSE CARDS */}

      <div
        className="container-fluid py-5"
        style={{ background: "#f5f5f5" }}
      >

        <div className="container">

          <div className="row g-4">

            {courses.map((course) => (

              <div
                className="col-lg-3 col-md-6"
                key={course.id}
              >

                <Coursecard
                  course={{
                    ...course,
                    universityName: "Sikkim Manipal University"
                  }}
                />

              </div>

            ))}

          </div>

        </div>

      </div>

    </>

  );
}